import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Link, Tooltip } from 'tdesign-react';

export function isSuperAdmin(roles) {
  return roles.includes('超级管理员');
}

// 体验环境，除超管不允许使用
function DisableWrapper({ children, roles, ...others }) {
  const element = useMemo(() => {
    if (typeof children === 'string') {
      return <Link>{children}</Link>;
    }
    return React.Children.only(children);
  }, [children]);

  const superAdmin = isSuperAdmin(roles);

  return superAdmin ? (
    React.cloneElement(children, others)
  ) : (
    <Tooltip content='体验环境暂不支持该功能'>
      <React.Fragment>
        {React.cloneElement(element, {
          disabled: true,
          ...others,
        })}
      </React.Fragment>
    </Tooltip>
  );
}

export default connect((state) => ({
  roles: state.auth.roles,
}))(DisableWrapper);
